import React/*, { useState, useEffect } */ from "react";
import { FooterComponent } from "../components";

function FooterContainer({ itemsArray }) {
  return <FooterComponent />;
}

export default FooterContainer;
